export const PERMISSIONS = {

  // activity
  ACTIVITY_MENU: "activity.menu",
  ACTIVITY_READ: "activity.read",
  ACTIVITY_ALL: "activity.all",
  ACTIVITY_CREATE: "activity.create",
  ACTIVITY_UPDATE: "activity.update",
  ACTIVITY_DELETE: "activity.delete",
  ACTIVITY_ASSIGN: "activity.assign",

  // negotiation
  NEGOTIATION_MENU: "negotiation.menu",
  NEGOTIATION_READ: "negotiation.read",
  NEGOTIATION_ALL: "negotiation.all",
  NEGOTIATION_CREATE: "negotiation.create",
  NEGOTIATION_UPDATE: "negotiation.update",
  NEGOTIATION_DELETE: "negotiation.delete",

  // negotiation.strategy
  STRATEGY_READ: "negotiation.strategy.read",
  STRATEGY_ALL: "negotiation.strategy.all",
  STRATEGY_CREATE: "negotiation.strategy.create",
  STRATEGY_UPDATE: "negotiation.strategy.update",
  STRATEGY_DELETE: "negotiation.strategy.delete",
  STRATEGY_APPROVE: "negotiation.strategy.approve",
  STRATEGY_REQUEST_PLANNING: "negotiation.strategy.request_planning",
  STRATEGY_CREATE_BRIEF: "negotiation.strategy.create_brief",

  // advertiser
  ADVERTISER_MENU: "advertiser.menu",
  ADVERTISER_READ: "advertiser.read",
  ADVERTISER_ALL: "advertiser.all",
  ADVERTISER_CREATE: "advertiser.create",
  ADVERTISER_UPDATE: "advertiser.update",
  ADVERTISER_DELETE: "advertiser.delete",

  // contact
  CONTACT_READ: "advertiser.contact.read",
  CONTACT_ALL: "advertiser.contact.all",
  CONTACT_CREATE: "advertiser.contact.create",
  CONTACT_UPDATE: "advertiser.contact.update",
  CONTACT_DELETE: "advertiser.contact.delete",

  // order
  ORDER_MENU: "order.menu",
  ORDER_READ: "order.read",
  ORDER_ALL: "order.all",
  ORDER_CREATE: "order.create",
  ORDER_UPDATE: "order.update",
  ORDER_DELETE: "order.delete",

  // quote
  QUOTE_MENU: "quote.menu",
  QUOTE_READ: "quote.read",
  QUOTE_ALL: "quote.all",
  QUOTE_CREATE: "quote.create",
  QUOTE_UPDATE: "quote.update",
  QUOTE_DELETE: "quote.delete",
  QUOTE_APPROVE: "quote.approve",

  //share
  SHARE_READ: "share.read",
  SHARE_CREATE: "share.create",
  SHARE_DELETE: "share.delete",
  SHARE_SEND: "share.send",

  // campaign
  CAMPAIGN_MENU: "campaign.menu",
  CAMPAIGN_READ: "campaign.read",
  CAMPAIGN_ALL: "campaign.all",
  CAMPAIGN_CREATE: "campaign.create",
  CAMPAIGN_UPDATE: "campaign.update",
  CAMPAIGN_DELETE: "campaign.delete",

  // planning
  PLANNING_MENU: "planning.menu",
  PLANNING_READ: "planning.read",
  PLANNING_ALL: "planning.all",
  PLANNING_CREATE: "planning.create",
  PLANNING_UPDATE: "planning.update",
  PLANNING_DELETE: "planning.delete",

  // system
  SYSTEM_MENU: "system.menu",
  SYSTEM_READ: "system.read",
  SYSTEM_ALL: "system.all",
  SYSTEM_CREATE: "system.create",
  SYSTEM_UPDATE: "system.update",
  SYSTEM_DELETE: "system.delete",

  // system.team
  TEAM_MENU: "system.team.menu",
  TEAM_READ: "system.team.read",
  TEAM_ALL: "system.team.all",
  TEAM_CREATE: "system.team.create",
  TEAM_UPDATE: "system.team.update",
  TEAM_DELETE: "system.team.delete",

  // system.team.management
  TEAM_MANAGEMENT_READ: "system.team.management.read",
  TEAM_MANAGEMENT_ALL: "system.team.management.all",
  TEAM_MANAGEMENT_CREATE: "system.team.management.create",
  TEAM_MANAGEMENT_UPDATE: "system.team.management.update",
  TEAM_MANAGEMENT_DELETE: "system.team.management.delete",

  // system.supplier
  SUPPLIER_READ: "system.supplier.read",
  SUPPLIER_ALL: "system.supplier.all",
  SUPPLIER_CREATE: "system.supplier.create",
  SUPPLIER_UPDATE: "system.supplier.update",
  SUPPLIER_DELETE: "system.supplier.delete",

  // system.document
  DOCUMENT_READ: "system.document.read",
  DOCUMENT_CREATE: "system.document.create",
  DOCUMENT_DELETE: "system.document.delete",

  // system.image
  SYSTEM_IMAGE_READ: "system.image.read",
  SYSTEM_IMAGE_ALL: "system.image.all",
  SYSTEM_IMAGE_CREATE: "system.image.create",
  SYSTEM_IMAGE_UPDATE: "system.image.update",
  SYSTEM_IMAGE_DELETE: "system.image.delete",

  // system.type
  SYSTEM_TYPE_READ: "system.type.read",
  SYSTEM_TYPE_ALL: "system.type.all",
  SYSTEM_TYPE_CREATE: "system.type.create",
  SYSTEM_TYPE_UPDATE: "system.type.update",
  SYSTEM_TYPE_DELETE: "system.type.delete",

  // system.device
  DEVICE_READ: "system.device.read",
  DEVICE_ALL: "system.device.all",
  DEVICE_CREATE: "system.device.create",
  DEVICE_UPDATE: "system.device.update",
  DEVICE_DELETE: "system.device.delete",

  // system.frame
  FRAME_READ: "system.frame.read",
  FRAME_ALL: "system.frame.all",
  FRAME_CREATE: "system.frame.create",
  FRAME_UPDATE: "system.frame.update",
  FRAME_DELETE: "system.frame.delete",

  // system.license
  LICENSE_MENU: "system.license.menu",
  LICENSE_READ: "system.license.read",
  LICENSE_ALL: "system.license.all",
  LICENSE_CREATE: "system.license.create",
  LICENSE_UPDATE: "system.license.update",
  LICENSE_DELETE: "system.license.delete",

  // mediaOwner
  MEDIA_OWNER_READ: "mediaOwner.read",
  MEDIA_OWNER_ALL: "mediaOwner.all",
  MEDIA_OWNER_CREATE: "mediaOwner.create",
  MEDIA_OWNER_UPDATE: "mediaOwner.update",
  MEDIA_OWNER_DELETE: "mediaOwner.delete",

  // detection
  DETECTION_MENU: "detection.menu",
  DETECTION_READ: "detection.read",
  DETECTION_ALL: "detection.all",
  DETECTION_CREATE: "detection.create",
  DETECTION_UPDATE: "detection.update",
  DETECTION_DELETE: "detection.delete",
  DETECTION_SEND_TO_CRM: "detection.send_to_crm",

  // detection.agent
  DETECTION_AGENT_READ: "detection.agent.read",
  DETECTION_AGENT_ALL: "detection.agent.all",
  DETECTION_AGENT_CREATE: "detection.agent.create",
  DETECTION_AGENT_UPDATE: "detection.agent.update",
  DETECTION_AGENT_DELETE: "detection.agent.delete",

  // detection.brandName
  DETECTION_BRAND_NAME_READ: "detection.brandName.read",
  DETECTION_BRAND_NAME_ALL: "detection.brandName.all",
  DETECTION_BRAND_NAME_CREATE: "detection.brandName.create",
  DETECTION_BRAND_NAME_UPDATE: "detection.brandName.update",
  DETECTION_BRAND_NAME_DELETE: "detection.brandName.delete",

  // detection.businessArea
  DETECTION_BUSINESS_AREA_READ: "detection.businessArea.read",
  DETECTION_BUSINESS_AREA_ALL: "detection.businessArea.all",
  DETECTION_BUSINESS_AREA_CREATE: "detection.businessArea.create",
  DETECTION_BUSINESS_AREA_UPDATE: "detection.businessArea.update",
  DETECTION_BUSINESS_AREA_DELETE: "detection.businessArea.delete",

  // detection.format
  DETECTION_FORMAT_READ: "detection.format.read",
  DETECTION_FORMAT_ALL: "detection.format.all",
  DETECTION_FORMAT_CREATE: "detection.format.create",
  DETECTION_FORMAT_UPDATE: "detection.format.update",
  DETECTION_FORMAT_DELETE: "detection.format.delete",

  // detection.mediaOwner
  DETECTION_MEDIA_OWNER_READ: "detection.mediaOwner.read",
  DETECTION_MEDIA_OWNER_ALL: "detection.mediaOwner.all",
  DETECTION_MEDIA_OWNER_CREATE: "detection.mediaOwner.create",
  DETECTION_MEDIA_OWNER_UPDATE: "detection.mediaOwner.update",
  DETECTION_MEDIA_OWNER_DELETE: "detection.mediaOwner.delete",

  // user
  USER_READ: "user.read",
  USER_ALL: "user.all",
  USER_CREATE: "user.create",
  USER_UPDATE: "user.update",
  USER_DELETE: "user.delete",
  USER_CHANGE_ROLE: "user.change_role",

  // sales users
  USER_ROLE: "user.role",

  //TEST
  TEST_ALL: "",
};